import { fixedStage } from '#packages/util';

export function shouldRunMigration() {
  return fixedStage.isFixedStageEnabled();
}
